// 전체적으로 보완 필요함
// _required, dateRequired 함수 참조. 힌트문구를 인자로 받을 수 있어야 함
// _함수는 직접 validate 에 사용할 수 없다. (redux-form 의 인자 전달 형식과 맞지 않음)

import moment from "moment";
import * as tagLib from "libs/tagLib";
import * as targetLib from "libs/targetLib";
import * as examLib from "libs/examLib";
import * as userLib from "libs/userLib";
import * as eduLib from "libs/eduLib";
import * as common from "libs/commonFunc";
import * as commonVar from "libs/commonVar";

const langObj = {
  ko: {
    vali_1: "최소",
    vali_2: "이상의 값만 가능합니다.",
    vali_3: "최대",
    vali_4: "이하의 값만 가능합니다.",
    vali_5: "값을 입력하세요.",
    vali_6: "숫자만 가능합니다.",
    vali_7: "영문만 가능합니다.",
    vali_8: "공백은 입력 할 수 없습니다.",
    vali_9: "올바르지 않은 이메일 양식입니다.",
    vali_10: "사용불가 문자 포함",
    vali_11: "날짜를 다시 선택하세요.",
    vali_12: "과거는 선택 할 수 없습니다.",
    vali_13: "대상 태그를 선택하세요.",
    vali_14: "값이 없습니다.",
    vali_15: "날짜를 선택하세요.",
    vali_16: "훈련 양식을 선택하세요.",
    vali_17: "압축 파일 종류를 선택하세요.",
    vali_18: "압축 파일 종류를 선택하세요.",
    vali_19: "수량은 1 이상입니다.",
    vali_20: "이미 사용중인 훈련명입니다.",
    vali_21: "이미 등록된 태그명입니다.",
    vali_22: "이미 등록된 이메일입니다.",
    vali_23: "알파벳을 포함하세요.",
    vali_24: "숫자를 포함하세요.",
    vali_25: "특수문자를 포함하세요.",
    vali_27: "자리 이상 입력하세요.",
    vali_28: "대문자를 포함하세요.",
    vali_29: "동일한 문자 ",
    vali_30: "연속된 문자 ",
    vali_31: "개 이상 제한",
    vali_32: "아이디랑 동일 문자 제한",
    vali_33: "가능한 확장자",
    vali_34: "파일명 마지막에 숫자를 입력 할 수 없습니다.",
    vali_35: "올바른 url이 아닙니다.",
    vali_36: "공백은 연속으로 입력 할 수 없습니다.",
    vali_37: "공백을 맨앞에 입력 할 수 없습니다.",
    vali_38: "공백을 맨뒤에 입력 할 수 없습니다.",
    vali_39: "최소값",
    vali_40: "최대값",
    vali_41: "최소 길이",
    vali_42: "최대 길이",
    vali_43: "입력 허용 범위",
    vali_44: "자",
    vali_45: "명 이하만 등록 가능합니다.",
    vali_46: "훈련 템플릿을 선택하세요.",
    vali_47:
      "접근 허용 IP 양식이 올바르지 않습니다. (Array형태가 아닌 값이 있음)",
    vali_48: "접근 허용 IP 양식이 올바르지 않습니다. (JSON 형태가 이상함)",
    vali_49: "이미 사용중인 교육명입니다.",
    vali_50: "교육 컨텐츠를 선택하세요.",
    vali_51: " ",
    vali_52: " ",
    vali_53: " ",
    vali_54: "URL 입력 양식이 올바르지 않습니다.",
    vali_55: "원본파일명 끝에는 숫자를 입력할 수 없습니다.",
    vali_56: "입력 양식이 올바르지 않습니다.",
  },
  ja: {
    vali_1: "最低",
    vali_2: "以上の値のみ可能です。",
    vali_3: "最大",
    vali_4: "以下の値のみ可能です。",
    vali_5: "値を入力してください。",
    vali_6: "数字のみ入力できます。",
    vali_7: "英字のみ入力できます。",
    vali_8: "スペースを空ける必要はありません。",
    vali_9: "メールアドレスの形式が正しくありません。",
    vali_10: "使用できない文字が含まれています",
    vali_11: "日付を改めて選択して下さい。",
    vali_12: "過去は選択できません。",
    vali_13: "対象者タグを選択してください。",
    vali_14: "値がありません。",
    vali_15: "日付を選択して下さい。",
    vali_16: "訓練様式を選択して下さい。",
    vali_17: "圧縮ファイルの種類を選択して下さい。",
    vali_18: "圧縮ファイルの種類を選択して下さい。",
    vali_19: "数量は1以上です。",
    vali_20: "すでに使用中の訓練名です。",
    vali_21: "すでに登録されているタグ名です。",
    vali_22: "すでに登録されているメールアドレスです。",
    vali_23: "小文字 a～z (ローマ字)を含む必要があります。",
    vali_24: "数字を含む必要があります。",
    vali_25: "特殊文字を含む必要があります。",
    vali_27: "文字以上で設定してください。",
    vali_28: "大文字 A～Z (ローマ字)を含む必要があります。",
    vali_29: "同じ文字",
    vali_30: "連続した文字",
    vali_31: "以上の制限",
    vali_32: "IDと同じ文字制限",
    vali_33: "可能な拡張子",
    vali_34: "ファイル名の最後に数字を入力することはできません",
    vali_35: "ドメインが正しくありません。",
    vali_36: "連続したスペースは入力できません。",
    vali_37: "開始時にスペースを入力することはできません",
    vali_38: "最後にスペースを入力することはできません",
    vali_39: "最小値",
    vali_40: "最大値",
    vali_41: "最小の長さ",
    vali_42: "最大の長さ",
    vali_43: "入力許容範囲",
    vali_44: "字",
    vali_45: "名以下のみ登録可能です。",
    vali_46: "訓練テンプレートを選択してください。",
    vali_47:
      "アクセスを許可したIPアドレスの形式が正しくありません(配列型ではない値がある)",
    vali_48:
      "アクセスを許可したIPアドレスの形式が正しくありません(JSON形式が正しくありません)",
    vali_49: "既に使用中の教育名です。",
    vali_50: "教育コンテンツを選択してください",
    vali_51: "same characters are not required",
    vali_52: "consecutive characters are not required",
    vali_53: "Up to",
    vali_54: "URL入力様式が正しくありません。",
    vali_55: "オリジナルのファイル名の最後には数字を入力できません。",
    vali_56: "入力フォームが正しくありません。",
  },
  en: {
    vali_1: "Only more than",
    vali_2: "values are possible.",
    vali_3: "Up to",
    vali_4: "values are possible.",
    vali_5: "Please enter a value.",
    vali_6: "only numbers are allowed.",
    vali_7: "only in English.",
    vali_8: "No spaces are allowed.",
    vali_9: "Invalid email form",
    vali_10: "Include unacceptable characters.",
    vali_11: "Please select a date again.",
    vali_12: "You cannot choose the past.",
    vali_13: "Please select a tag for trainee.",
    vali_14: "No value found",
    vali_15: "Please select a date.",
    vali_16: "Please select a template.",
    vali_17: "Please select the type of compressed type.",
    vali_18: "Please select a compressed file type.",
    vali_19: "Quantity is more than 1.",
    vali_20: "This training name is already in use.",
    vali_21: "This tag name is already in use.",
    vali_22: "This email address is already in use.",
    vali_23: "Please include the alphabet.",
    vali_24: "Please include the numbers.",
    vali_25: "Please include special characters.",
    vali_27: "is required",
    vali_28: "Please include capital letters.",
    vali_29: " ",
    vali_30: " ",
    vali_31: " ",
    vali_32: "The same character as the ID cannot be used for the password.",
    vali_33: "Possible extensions",
    vali_34: "You cannot enter a number at the end of file name.",
    vali_35: "Not a valid URL",
    vali_36: "No spaces allowed",
    vali_37: "You cannot enter a space at the beginning.",
    vali_38: "You cannot type a space at the end.",
    vali_39: "Minimum value",
    vali_40: "Maximum value",
    vali_41: "Minimum length",
    vali_42: "Maximum length",
    vali_43: "Enter allowed range",
    vali_44: "letter",
    vali_45: " ",
    vali_46: "Select the training template",
    vali_47:
      "Invalid access permission IP (There is a value that is not an Array type)",
    vali_48: "Invalid access permission IP (Strange JSON type)",
    vali_49: "This name is already in use",
    vali_50: "Select the contents",
    vali_51: "same characters are not required",
    vali_52: "consecutive characters are not required",
    vali_53: "Up to",
    vali_54: "Invalid URL",
    vali_55: "You cannot enter a number at the end of the original file name.",
    vali_56: "Input form is invalid",
  },
};

let language =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
const lang =
  langObj[
    !!localStorage.getItem("language")
      ? localStorage.getItem("language")
      : languageWithoutRegionCode
  ];

// [GS 인증] 범위 지정
const _range = (value, start, end, hintMsg) => {
  hintMsg =
    typeof hintMsg === "undefined"
      ? lang.vali_43 +
        ": [ " +
        (start > 0 ? start + "~" : "") +
        end +
        lang.vali_44 +
        " ]"
      : hintMsg;
  return String(value).length < start || String(value).length > end
    ? hintMsg
    : undefined;
};

export const range15 = (value) => _range(value, 0, 15);
export const range50 = (value) => _range(value, 0, 50);
export const rangeID = (value) => _range(value, 5, 50);
export const range100 = (value) => _range(value, 0, 100);
export const range200 = (value) => _range(value, 0, 200);
export const range320 = (value) => _range(value, 0, 320);
export const range5000 = (value) => _range(value, 0, 5000);

// [GS 인증]
export const gsPassword = (value) => {
  if (commonVar.isGs === 1) {
    if (!!value) {
      if (typeof _range(value, 8, 15) !== "undefined") {
        return _range(value, 8, 15);
      }

      if (!value.match(new RegExp(/[a-zA-z]/))) {
        return lang.vali_23;
      }

      if (!value.match(new RegExp(/[0-9]/))) {
        return lang.vali_24;
      }

      if (!value.match(new RegExp(/[!@#$%^&+=]/))) {
        return lang.vali_25;
      }
    }
  }

  return undefined;
};
// GS인증 smtp ID
export const RegExpID = new RegExp(/[^a-zA-Z0-9]/);
export const mailId = (value) => {
  if (!value.match(new RegExp(/[a-zA-z]/))) {
    return lang.vali_23;
  }

  const fail = value.match(RegExpID);
  return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
};
// GS인증 smtp PW
export const RegExpPW = new RegExp(
  /[^a-zA-Z0-9 ,.\(\)\[\]=+!@#$%\^&\*:;'"\/<>?~_\-\\]/
);
export const mailPassword = (value) => {
  const fail = value.match(RegExpPW);
  return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
};
export const templatePW = (value) => {
  const fail = value.match(RegExpID);

  // 공백의 경우
  if (!!fail && fail[0] === " ") {
    return lang.vali_8;
  }

  return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
};

// 공백 처리 (2개이상의 공백)
export const RegExpBlankDup = new RegExp(/\s{2,}/);
// 공백 처리 (시작에 공백)
export const RegExpBlankStart = new RegExp(/^\s/);
// 공백 처리 (끝에 공백)
export const RegExpBlankEnd = new RegExp(/\s$/);

export const RegExpDefault = new RegExp(
  /[^ㄱ-ㅎㅏ-ㅣ가-힣一-龯豈-龎ぁ-ゟ々－ァ-ヿ゛゜ーa-zA-Z0-9ａ-ｚＡ-Ｚ０-９()_\-]/
);
export const RegExpDefaultBlank = new RegExp(
  /[^ㄱ-ㅎㅏ-ㅣ가-힣一-龯豈-龎ぁ-ゟ々－ァ-ヿ゛゜ーa-zA-Z0-9ａ-ｚＡ-Ｚ０-９&()_\-\/\. 　]/
);
export const RegExpTemplateName = new RegExp(
  /[^ㄱ-ㅎㅏ-ㅣ가-힣一-龯豈-龎ぁ-ゟ々－ァ-ヿ゛゜ーa-zA-Z0-9ａ-ｚＡ-Ｚ０-９ ,.\(\)\[\]=+!@#$%\^&\*:;'"\/<>?~_\-\\]/
);
export const RegExpPhone = new RegExp(/[^0-9 \-+]/);
export const RegExpWindowsFile = new RegExp(/[:\\/%*?:|\"<>]/);
export const RegExpEmail = new RegExp(
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i
);
export const RegExpServiceDomain = new RegExp(/^[A-Z0-9.-]+\.[A-Z]{2,10}$/i);
export const RegExpExe = new RegExp(/^(?!.*\.exe$).*$/i);
export const RegExpPdf = new RegExp(/^(?!.*\.pdf$).*$/i);
export const RegExpLnk = new RegExp(/^(?!.*\.lnk$).*$/i);
export const RegExpDocx = new RegExp(/^(?!.*\.docx$).*$/i);
export const RegExpHtml = new RegExp(/^(?!.*\.html$).*$/i);
export const RegExpZip = new RegExp(/^(?!.*\.zip$).*$/i);
export const RegExp7z = new RegExp(/^(?!.*\.7z$).*$/i);
// 사용 안함
export const RegExpURL = new RegExp(
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i
);

const _blank = (value) => {
  if (value.match(RegExpBlankDup)) {
    return lang.vali_36;
  }
  if (value.match(RegExpBlankStart)) {
    return lang.vali_37;
  }
  if (value.match(RegExpBlankEnd)) {
    return lang.vali_38;
  }
  return undefined;
};
const _required = (value, hintMsg) => {
  hintMsg = typeof hintMsg === "undefined" ? lang.vali_5 : hintMsg;
  return value === undefined || value === null || value === ""
    ? hintMsg
    : undefined;
};
const _minNumber = (value, min, hintMsg) => {
  hintMsg =
    typeof hintMsg === "undefined"
      ? lang.vali_1 + " '" + min + "' " + lang.vali_2
      : hintMsg;
  return !isNaN(Number(value)) && !isNaN(Number(min)) && value < min
    ? hintMsg
    : undefined;
};
const _maxNumber = (value, max, hintMsg) => {
  hintMsg =
    typeof hintMsg === "undefined"
      ? lang.vali_3 + " '" + max + "' " + lang.vali_4
      : hintMsg;
  return !isNaN(Number(value)) && !isNaN(Number(max)) && value > max
    ? hintMsg
    : undefined;
};

// 한글, 영문, 일본어, 숫자
export const _hangulAlphabetNumber = (value) => {
  if (typeof value !== "undefined" && !!value) {
    if (!!_blank(value)) {
      return _blank(value);
    }

    if (!!range50(value)) {
      return range50(value);
    }

    const fail = value.match(RegExpDefaultBlank);

    // 공백의 경우
    if (!!fail && fail[0] === " ") {
      return lang.vali_8;
    }

    return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
  }
};

export const required = (value) => _required(value, lang.vali_14);
export const dateRequired = (value) => _required(value, lang.vali_15);
export const templateRequired = (value) => _required(value, lang.vali_16);
export const blank = (value) => _blank(value);
export const targetName = (value) => _hangulAlphabetNumber(value);
export const targetDivision = (value) => _hangulAlphabetNumber(value);
export const targetPosition = (value) => _hangulAlphabetNumber(value);
export const examTemplateAttachFileCompressTypeMin = (value) =>
  _minNumber(value, 1, lang.vali_17);
export const examTemplateAttachFileCompressTypeMax = (value) =>
  _maxNumber(value, 4, lang.vali_18);
export const licenseCountMin = (value) => _minNumber(value, 1, lang.vali_19);
export const licenseCountMax = (value) =>
  _maxNumber(value, 100000, "100000" + lang.vali_45);
export const maxLength = (max) => (value) =>
  value && value.length > max ? lang.vali_42 + `: [ ${max} ]` : undefined;
export const minLength = (min) => (value) =>
  value && value.length < min ? lang.vali_41 + `: [ ${min} ]` : undefined;
export const minValue = (min) => (value) =>
  value && value < min ? lang.vali_39 + `: [ ${min} ]` : undefined;
export const maxValue = (max) => (value) =>
  value && value > max ? lang.vali_40 + `: [ ${max} ]` : undefined;
export const number = (value) =>
  value && isNaN(Number(value)) ? lang.vali_6 : undefined;
export const maxNumber = (value) =>
  value > 2147483647 ? lang.vali_43 + " [2,147,483,647] " : undefined;
export const email = (value) => {
  if (!!range320(value)) {
    return range320(value);
  }

  return value && !RegExpEmail.test(value) ? lang.vali_9 : undefined;
};
// 훈련 템플릿의 다운로드 유형, 첨부 유형
export const templateType = (value) =>
  value && value < 1 ? lang.vali_14 : undefined;

// 태그명, 훈련명, 서비스명, 교육명, 사용자명
export const tagName = (value) => {
  if (typeof value !== "undefined" && !!value) {
    if (!!_blank(value)) {
      return _blank(value);
    }

    if (!!range50(value)) {
      return range50(value);
    }

    const fail = value.match(RegExpDefaultBlank); // 전각 스페이스 가능

    // 공백의 경우
    if (!!fail && fail[0] === " ") {
      return lang.vali_8;
    }

    return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
  }
};
export const examName = tagName;
export const serviceName = tagName;
export const senderName = tagName;
export const eduName = tagName;

// 서비스 사용자 이름
export const userName = tagName;

// 템플릿 이름
export const templateName = (value) => {
  if (typeof value !== "undefined" && !!value) {
    if (!!range50(value)) {
      return range50(value);
    }

    const fail = value.match(RegExpTemplateName);

    // 공백의 경우
    if (!!fail && fail[0] === " ") {
      return lang.vali_8;
    }

    return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
  }
};

// 연락처 일반 전화번호, 외국번호등의 다양한 가능성이 있으므로 숫자와 -만 체크한다.
export const userPhone = (value) => {
  if (typeof value !== "undefined" && !!value) {
    if (!!_blank(value)) {
      return _blank(value);
    }

    if (!!range15(value)) {
      return range15(value);
    }

    const fail = value.match(RegExpPhone);

    // 공백의 경우
    if (!!fail && fail[0] === " ") {
      return lang.vali_8;
    }

    return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
  }
};

// 윈도우에서 사용 가능한 파일명 체크
export const windowsFileName = (value) => {
  if (typeof value !== "undefined" && !!value) {
    if (!!range200(value)) {
      return range200(value);
    }

    const fail = value.match(RegExpWindowsFile);
    return !!fail ? lang.vali_10 + ": [ " + fail[0] + " ]" : undefined;
  }
};

// 시스템 훈련 URL
export const examSystemUrl = (value) => {
  if (typeof value !== "undefined" && !!value) {
    const regexp = /^[\[]("(http(s?)\:\/\/)[a-zA-Z1-9\-.]+(")[,\s]*)+[\]]$/g;
    const success = value.match(regexp);
    if (!success) {
      return lang.vali_54;
    } else {
      return undefined;
    }
  }
};

// 접근 허용 IP
export const accessAllowIp = (value) => {
  if (typeof value !== "undefined" && !!value) {
    try {
      const ipData = JSON.parse(value);
      let isNoArray = false;
      Object.values(ipData).map((data) => {
        if (!Array.isArray(data)) {
          isNoArray = true;
        }
      });

      if (isNoArray) {
        return lang.vali_47;
      } else {
        return undefined;
      }
    } catch (e) {
      return lang.vali_48;
    }
  }
};

//
export const reduxFormDatePicker = (value) => {
  return value && (!moment.isMoment(value) || !moment(value).isValid())
    ? lang.vali_11
    : undefined;
};

// 공백
export const space = (value) => {
  const fail = String(value).match(/\s/gi);
  return !!fail ? lang.vali_8 : undefined;
};

// 대상자 태그 선택
export const examTargetRequried = (value) => {
  return value ? undefined : lang.vali_13;
};

// 교육 대상자 태그 선택
export const eduTargetRequried = (value) => {
  return value ? undefined : lang.vali_13;
};

// 교육 컨텐츠 선택
export const eduAttachRequried = (value) => {
  return value ? undefined : lang.vali_50;
};

// 대상자 태그 선택
// export const licenseRequried = value => {
//   return value ? undefined : '라이센스 불가';
// };

// 확장자 exe
// export const extensionExe = value => (value && RegExpExe.test(value) ? lang.vali_33 + ': exe' : undefined);
// export const extensionPdf = value => (value && RegExpPdf.test(value) ? lang.vali_33 + ': pdf' : undefined);
// export const extensionLnk = value => (value && RegExpLnk.test(value) ? lang.vali_33 + ': lnk' : undefined);
// export const extensionDocx = value => (value && RegExpDocx.test(value) ? lang.vali_33 + ': docx' : undefined);
// export const extensionHtml = value => (value && RegExpHtml.test(value) ? lang.vali_33 + ': html' : undefined);

// 훈련 템플릿 선택
export const examTemplateRequried = (value) => {
  return value ? undefined : lang.vali_46;
};

// 템플릿 첨부 파일 확장자
export const extensionAttachCompress = (value) =>
  value && RegExpZip.test(value) && RegExp7z.test(value)
    ? lang.vali_33 + ": zip, 7z"
    : undefined;

// rtl
export const rtl = (value) => {
  if (value) {
    const pureFileName = value.slice(0, value.lastIndexOf(".exe"));
    if (/[\d]$/.test(pureFileName)) {
      return lang.vali_34;
    }
  }
  return undefined;
};

// 첨부파일 원본파일명
export const attachName = (value) => {
  if (value) {
    const pureFileName = value.slice(0, value.lastIndexOf("."));
    if (/\d+$/.test(pureFileName)) {
      return lang.vali_55;
    }
  }
  return undefined;
};

// url 정규식
// export const extensionUrl = value => (value && !RegExpURL.test(value) ? lang.vali_35 : undefined);
export const extensionUrl = (value) =>
  value && false ? lang.vali_35 : undefined;

// 라이센스 도메인
export const serviceDomainName = (value) => {
  if (!!range50(value)) {
    return range50(value);
  }

  return value && !RegExpServiceDomain.test(value) ? lang.vali_35 : undefined;
};

// 날짜 정규식 과거는 제한
export const dateFuture = (value) => {
  if (!!value) {
    if (
      common.epochFromDate(value) ===
      common.epochFromDate(common.timeFormatFromUTCEpoch(common.nowEpoch(), 3))
    ) {
      // return undefined;
      return (
        common.epochFromDate(value) +
        " -1- " +
        common.epochFromDate(
          common.timeFormatFromUTCEpoch(common.nowEpoch(), 3)
        )
      );
      // 정상
    } else if (
      common.epochFromDate(value) >
      common.epochFromDate(common.timeFormatFromUTCEpoch(common.nowEpoch(), 3))
    ) {
      return undefined;
      return (
        common.epochFromDate(value) +
        " -2- " +
        common.epochFromDate(
          common.timeFormatFromUTCEpoch(common.nowEpoch(), 3)
        )
      );

      return lang.vali_12;
    }
  }
};

// 비밀번호 처리
export const passwordVlidation = (value) => {
  const failArray = [];
  // 알파벳을 포함
  if (1 & value.bit) {
    failArray.push(lang.vali_23);
  }
  // 숫자 포함
  if (2 & value.bit) {
    failArray.push(lang.vali_24);
  }
  // 특수문자 포함
  if (4 & value.bit) {
    failArray.push(lang.vali_25);
  }
  // 최소 길이
  if (8 & value.bit) {
    failArray.push(lang.vali_1 + " " + value.detail["8"] + lang.vali_27);
  }
  // 대문자 포함
  if (16 & value.bit) {
    failArray.push(lang.vali_28);
  }
  // 동일 문자 제한
  if (32 & value.bit) {
    failArray.push(
      lang.vali_29 + " " + value.detail["32"] + lang.vali_31 + lang.vali_51
    );
  }
  // 연속된 문자 제한
  if (64 & value.bit) {
    failArray.push(
      lang.vali_30 + " " + value.detail["64"] + lang.vali_31 + lang.vali_52
    );
  }
  // 아이디 포함
  if (128 & value.bit) {
    failArray.push(lang.vali_32);
  }

  return failArray;
};

export const minValue1 = minValue(1);
export const minValue8 = minValue(8);
export const maxValue50 = maxValue(50);
export const minValue60 = minValue(60);
export const maxValue15 = maxValue(15);
export const maxValue100 = maxValue(100);
export const maxValue180 = maxValue(180);
export const maxLength20 = maxLength(20);
export const maxLength100 = maxLength(100);

// ---------------------------------------------- async validation -------------------------------------------------------

// 훈련명 중복 체크
export const examNameAsyncValidate = async (values, dispatch, props) => {
  if (values.examName) {
    // [수정] 초기값과 같을경우는 제외
    if (
      !!props.initialValues &&
      props.initialValues.examName === values.examName
    ) {
      return Promise.resolve({});
    }

    try {
      const respObj = await examLib.getExam({
        filter: JSON.stringify({ examNameExact: values.examName }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return Promise.reject({
          examName: lang.vali_20,
        });
      } else {
        return Promise.resolve({});
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return Promise.resolve({});
  }
};

// 태그명 중복 체크
export const tagNameAsyncValidate = async (values, dispatch, props) => {
  if (values.tagName) {
    // [수정] 초기값과 같을경우는 제외
    if (
      !!props.initialValues &&
      props.initialValues.tagName === values.tagName
    ) {
      return Promise.resolve({});
    }

    try {
      const respObj = await tagLib.getTagAPI({
        filter: JSON.stringify({ tagNameExact: values.tagName }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return Promise.reject({
          tagName: lang.vali_21,
        });
      } else {
        return Promise.resolve({});
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return Promise.resolve({});
  }
};

// 대상자 이메일 중복 체크
export const targetEmailAsyncValidate = async (values, dispatch, props) => {
  if (values.targetEmail) {
    // [수정] 초기값과 같을경우는 제외
    if (
      !!props.initialValues &&
      props.initialValues.targetEmail === values.targetEmail
    ) {
      return Promise.resolve({});
    }

    try {
      const respObj = await targetLib.getTargetAPI({
        tagNoArray: "all-tag",
        filter: JSON.stringify({ targetEmailExact: values.targetEmail }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return Promise.reject({
          targetEmail: lang.vali_22,
        });
      } else {
        return Promise.resolve({});
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return Promise.resolve({});
  }
};

// 사용자 이메일 중복 체크
export const userEmailAsyncValidate = async (values, dispatch, props) => {
  if (values.userEmail) {
    // [수정] 초기값과 같을경우는 제외
    if (
      !!props.initialValues &&
      props.initialValues.userEmail === values.userEmail
    ) {
      return Promise.resolve({});
    }

    try {
      const respObj = await userLib.getUser({
        filter: JSON.stringify({ userEmailExact: values.userEmail }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return Promise.reject({
          userEmail: lang.vali_22,
        });
      } else {
        return Promise.resolve({});
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return Promise.resolve({});
  }
};

// 교육명 중복 체크
export const eduNameAsyncValidate = async (values, dispatch, props) => {
  if (values.eduName) {
    // [수정] 초기값과 같을경우는 제외
    if (
      !!props.initialValues &&
      props.initialValues.eduName === values.eduName
    ) {
      return Promise.resolve({});
    }

    try {
      const respObj = await eduLib.getEduAPI({
        filter: JSON.stringify({ eduNameExact: values.eduName }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return Promise.reject({
          eduName: lang.vali_49,
        });
      } else {
        return Promise.resolve({});
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return Promise.resolve({});
  }
};

// ---------------------------------- 중복 체크 -------------------------------------

// 훈련명 중복 체크
export const examNameValidate = async (value) => {
  if (value) {
    try {
      const respObj = await examLib.getExam({
        filter: JSON.stringify({ examNameExact: value }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return lang.vali_20;
      } else {
        return undefined;
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return undefined;
  }
};

// 태그명 중복 체크
export const tagNameValidate = async (value) => {
  if (value) {
    try {
      const respObj = await tagLib.getTagAPI({
        filter: JSON.stringify({ tagNameExact: value }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return lang.vali_21;
      } else {
        return undefined;
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return undefined;
  }
};

// 대상자 이메일 중복 체크
export const targetEmailValidate = async (value) => {
  if (value) {
    try {
      const respObj = await targetLib.getTargetAPI({
        tagNoArray: "all-tag",
        filter: JSON.stringify({ targetEmailExact: value }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return lang.vali_22;
      } else {
        return undefined;
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return undefined;
  }
};

// 사용자 이메일 중복 체크
export const userEmailValidate = async (value) => {
  if (value) {
    try {
      const respObj = await userLib.getUser({
        filter: JSON.stringify({ userEmailExact: value }),
      });
      if (
        respObj &&
        respObj.status &&
        respObj.status === 200 &&
        respObj.data &&
        Array.isArray(respObj.data.list) &&
        respObj.data.list.length > 0
      ) {
        return lang.vali_22;
      } else {
        return undefined;
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    return undefined;
  }
};

// 대상자 연동 계정 설정 값 체크
export const userAccount = (value) => {
  if (typeof value !== "undefined" && !!value) {
    try {
      const json = JSON.parse(value);

      if (json) {
        return undefined;
      } else {
        return lang.vali_56;
      }
    } catch (e) {
      return lang.vali_56;
    }
  }
};



// WEBPACK FOOTER //
// ./src/script/libs/validation.js